/**
 * Created by ml on 2017-05-04.
 */
require('ta-semantic-ui/semantic/dist/components/reset.css')
require('ta-semantic-ui/semantic/dist/components/site.css')
require('ta-semantic-ui/semantic/dist/components/segment.css')
require('ta-semantic-ui/semantic/dist/components/header.css')
require('ta-semantic-ui/semantic/dist/components/container.css')
require('ta-semantic-ui/semantic/dist/components/icon.css')
require('ta-semantic-ui/semantic/dist/components/list.css')
require('ta-semantic-ui/semantic/dist/components/button.css')
require('ta-semantic-ui/semantic/dist/components/divider.css')
require('ta-semantic-ui/semantic/dist/components/table.css')
require('ta-semantic-ui/semantic/dist/components/rail.css')
require('../main/App.css')

import React from 'react'
import AudioPlayer from '../../components/audioplayer'
import Profile from '../../components/profile'
import Answer from '../../components/answer'
import Question from '../../components/question'
import { Waypoint } from 'react-waypoint'
// import Tracking from 'ta-react-polymorphic-tracking';

export default class FollowUp extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      overlayDisplay: 'block',
      followupClass: 'collapsed',
      articleLoaded: false
    }

    // Set up dataLayer for event tracking
    // This assumes we have GTM set up, otherwise not much will happen.
    window.dataLayer = window.dataLayer || []

    this.showArticle = this.showArticle.bind(this)
    let followupTracking = ''
  }

  render() {
    return (
      <div className='followup'>
        <div
          className='overlay'
          style={{ display: `${this.state.overlayDisplay}` }}
        >
          <div className='ui center aligned fluid container'>
            <p>Lesen Sie das Sex-Interview der Frauen</p>
            <a onClick={this.showArticle} className='ui big basic white button'>
              {' '}
              <i className='angle double down icon' />
              Artikel anzeigen
            </a>
          </div>
        </div>

        <main className={`follow-up ${this.state.followupClass}`}>
          <header
            className='ui inverted vertical segment'
            style={{
              backgroundImage: `url(${require('./header.jpg')})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover'
            }}
          >
            <div className='ui container'>
              <h1 className='ui huge red centered header'>
                Sechs Frauen über Sex
              </h1>
            </div>
          </header>

          <figcaption className='ui container ta caption'>
            Der privateste Moment öffentlich geteilt: Der litauische Fotograf
            Albert Pocej fotografiert Frauen beim Höhepunkt.
          </figcaption>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <p className='ta lead'>
                Das erste Mal, Selbstbefriedigung, Fantasien – Was 30-Jährige im
                Bett wollen. Ein Gespräch.
              </p>
              <p className='ta lead author'>
                Von Michèle Binswanger und Salome Müller
              </p>

              <p className='ta lead'>
                Während junge Männer meist sehr schnell für sich entdecken, was
                und wie sie begehren – und es auch eine ganze Industrie gibt,
                die ihre allfälligen Bedürfnisse abdeckt, ist das Thema bei
                Frauen trotz aller Befreiung schambehaftet. Auch unter
                Freundinnen wird kaum über Sex geredet. Oft braucht es Jahre,
                manchmal Jahrzehnte, bis eine Frau den eigenen Körper weit genug
                entdeckt hat, um beim Sex Lust zu empfinden, oder gar einen
                Orgasmus zu erleben.
              </p>
              <p className='ta lead'>
                Mit dreissig sind Frauen meistens so weit mit sich und ihrem
                Körper im Reinen, dass sie wissen, was sie wollen und was nicht.
                Wir haben sechs Dreissigjährige erzählen lassen, was sie im
                vergangenen Jahrzehnt über sich und ihre Sexualität gelernt
                haben
              </p>
              <p className='ta lead'>
                Ein Tisch, sechs Frauen, Tequila-Shots und das Thema Sex. Die
                erste Frage liegt auf der Hand.
              </p>

              <Question
                q='Wann hattet ihr zum ersten Mal Sex, was war das für eine Erfahrung?'
                classes='ui small red header'
              >
                <div className='ui center aligned fluid container'>
                  <AudioPlayer
                    source={require('./audioclip-erste-frage.mp4')}
                    audioTitle='Die erste Frage des Gesprächs.'
                  />
                </div>

                <Answer who='Annabelle'>
                  <p>
                    Ich war 13 und vier Monate mit meinem Freund zusammen, es
                    war auch sein erstes Mal. Ich hatte keine besonderen
                    Erwartungen, es war sehr schön, unbeschwert.{' '}
                  </p>
                </Answer>

                <Answer who='Lisa'>
                  <p>
                    Ich war 16, und es war auch mit meinem ersten Freund. Ich
                    habe sehr neutrale Erinnerungen. Wir blieben vier Jahre
                    zusammen. Der Sex wurde besser, aber es war auch eine
                    Belastung. Am Wochenende wusste ich: Jetzt müssen wir wieder
                    Sex haben. Ich dachte, er will das, aber gesprochen haben
                    wir nie darüber.{' '}
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Ich war 17, es war mein erster Freund, vier Jahre älter. Ich
                    fühlte mich unter Druck, dass man in diesem Alter eigentlich
                    schon hätte Sex haben sollen. Es war nicht besonders, ich
                    war einfach froh, es hinter mir zu haben.
                  </p>
                </Answer>

                <Answer who='Anouk'>
                  <p>
                    Ich war 18 und seit einem Monat mit meinem gleichaltrigen
                    Freund zusammen. Es war nicht mega prickelnd, aber tat auch
                    nicht weh.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Ich war knapp 18 und wollte mein erstes Mal endlich hinter
                    mich bringen. Ich war eine Woche in Hamburg in den Ferien
                    und lernte einen im Ausgang kennen. Wir hatten Sex im
                    Badezimmer. Als es blutete, sagte ich, ich hätte meine Tage,
                    weil ich nicht zugeben wollte, dass ich Jungfrau war. Es tat
                    nicht weh. Danach war der Druck weg. Ein paar Monate später
                    hatte ich dann meine erste richtige Beziehung.
                  </p>
                </Answer>

                <Answer who='Zoé'>
                  <p>
                    Ich war 16 und kam gerade aus einer Beziehung. Nach einer
                    Party übernachtete ich bei einem Mitschüler, wir waren im
                    Elternschlafzimmer. Konkrete Erinnerungen habe ich nicht,
                    ich weiss nur, dass es mir viel bedeutet hatte, weil ich
                    sehr fest in ihn verliebt war.
                  </p>
                </Answer>
              </Question>
            </div>
          </section>

          <aside className='ui vertical red fitted segment'>
            <div className='ui container'>
              <div className='ui relaxed two column stackable grid'>
                <div className='column'>
                  <Profile
                    avatarSrc={require('./../main/avatar-7.svg')}
                    name='Annabelle, 30, Ökonomin'
                  >
                    {' '}
                    Seit einem Jahr in einer Beziehung. Sprach mit ihrem
                    Exfreund oft über alternative Beziehungsformen. Empfände
                    eine offene Beziehung aber als belastend.{' '}
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    avatarSrc={require('./avatar-8.svg')}
                    name='Anouk, 30, Studentin'
                  >
                    {' '}
                    Seit sechs Jahren in einer Beziehung. Sagte im Gespräch zum
                    ersten Mal, dass sie sich schon als Mädchen selbst
                    erkundete. Mag beim Sex die Intimität.{' '}
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    name='Ivana, 31, Journalistin'
                    avatarSrc={require('./avatar-9.svg')}
                  >
                    {' '}
                    Seit neun Jahren in einer Beziehung. Hatte in ihrer
                    Singlephase das Gefühl, sich beim Sex weniger zu entblössen.
                    Fände einen Dreier mit zwei Männern schön – als Kopfkino.{' '}
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    name='Lisa, 29, Doktorandin'
                    avatarSrc={require('./avatar-10.svg')}
                  >
                    {' '}
                    Seit zwei Jahren in einer Beziehung. Fragte ihren Exfreund,
                    warum er nicht mehr Sex wollte. Geniesst es, wenn nicht
                    immer der Orgasmus das Ziel ist.{' '}
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    name='Rahel, 29, Bankerin'
                    avatarSrc={require('./avatar-11.svg')}
                  >
                    {' '}
                    Seit zwei Jahren in einer Beziehung. War froh, als sie mit
                    17 endlich das erste Mal hinter sich brachte. Redet erst mit
                    dem jetzigen Partner über Sex.{' '}
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    name='Zoé, 30, Lehrerin'
                    avatarSrc={require('./avatar-12.svg')}
                  >
                    {' '}
                    Seit 10 Jahren in einer Beziehung. Weiss, dass ihr Freund
                    Pornos schaut. Fragt sich, ob sie je einen Orgasmus hatte.{' '}
                  </Profile>
                </div>
              </div>
            </div>
          </aside>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <Question
                q='Habt ihr euch zu dem Zeitpunkt schon einmal selbst befriedigt?'
                classes='ui small red header'
              >
                <Answer who='Zoé'>
                  <p>
                    Ich hatte nie rumexperimentiert. Es war schon klar, dass ich
                    Sex haben wollte, vor meinem ersten Mal hatten wir es auch
                    ein paar Mal probiert, aber es klappte nie, weil er nicht
                    reinkam.{' '}
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Ich befriedigte mich schon relativ früh selbst, etwa mit 12.
                    Bevor ich Sex hatte, hatte ich Softpetting gemacht, aber
                    nichts Orales.
                  </p>
                </Answer>

                <Answer who='Anouk'>
                  <p>
                    Bei mir fing das etwa mit 10 an. Mädchen machen das
                    anscheinend, um sich zu beruhigen. So würde ich auch meine
                    ersten Erfahrungen beschreiben: Es war ein angenehmes
                    Gefühl, mehr ein Kopfkino als etwas Sexuelles. Ich schämte
                    mich sehr, dass ich mich selbst befriedigte. Ich glaube, ich
                    sage das hier zum ersten Mal.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Ich war mit 13 schon entwickelt, las Liebesromane und das
                    «Bravo». Selbstbefriedigung hatte vor allem mit Wohlbefinden
                    zu tun. Meine Mutter bekam das wohl mit, aber es war mir
                    peinlich, darüber zu reden. Meine erste richtige
                    Pettingerfahrung hatte ich mit 14, mit meinem damaligen
                    Tennistrainer, der sieben Jahre älter war als ich. Es war,
                    als hätte ich versucht, in einer anderen Liga zu spielen,
                    weil ich immer dachte, ich sei hintendrein.
                  </p>
                </Answer>

                <Answer who='Lisa'>
                  <p>
                    Für mich war Sex immer verbunden mit einem Partner. An
                    Selbstbefriedigung dachte ich nie. Das war erst an der Uni
                    ein Thema, mit Anfang 20. Ich dachte, vielleicht bin ich
                    komisch, wenn ich dieses Bedürfnis nicht habe. Meine Mutter
                    erzählte mir aber, dass ich als Kind im Badezimmer mit einem
                    Spiegel zwischen meine Beine geguckt habe, wie es da unten
                    aussieht, aus kindlicher Neugier.
                  </p>
                </Answer>

                <Answer who='Annabelle'>
                  <p>
                    Selber befriedigt habe ich mich sehr selten, dieses
                    Bedürfnis fehlte. Sex war bei mir immer auf einen Mann
                    bezogen, aber ich war halt immer in einer Beziehung. Lange
                    hatte ich deshalb das Gefühl, dass etwas nicht mit mir
                    stimmt. Mit meinem ersten Freund machte ich aber viel
                    Petting, wir haben uns gegenseitig, miteinander entdeckt. Es
                    war locker, irgendwann ging es beim Petting einfach weiter,
                    und dann schliefen wir miteinander.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Mit wem habt ihr über Sex gesprochen?'
                classes='ui small red header'
              >
                <Answer who='Rahel'>
                  <p>
                    Ich las im «Bravo» darüber. Unter Freundinnen war es nie ein
                    Thema.
                  </p>
                </Answer>{' '}
                <Answer who='Ivana'>
                  <p>
                    Bei uns auch nicht. Wenn das jemand herausgefunden hätte,
                    hätte ich mich sehr geschämt.
                  </p>
                </Answer>{' '}
                <Answer who='Lisa'>
                  <p>
                    Im Fernsehen wurde das besprochen, in Bezug auf Männer. Weil
                    ich mit meinen Freundinnen nicht darüber gesprochen habe,
                    habe ich mich dann gefragt: Bin es jetzt ich, die anders
                    ist, oder sind es sie? Sind es wir Frauen oder die Männer?
                    Irgendwann entschied ich, dass das eigentlich egal ist.
                  </p>
                </Answer>{' '}
                <Answer who='Annabelle'>
                  <p>
                    Die Reaktion der Jungs auf das Thema war immer eher
                    erstaunt: Was, du machst das nicht? Für mich war klar: Nein,
                    mache ich nicht. Anscheinend war das schräg.
                  </p>
                </Answer>{' '}
              </Question>
            </div>
          </section>

          <figure className='ui vertical very fitted segment'>
            <img
              src={require('./pocej-2.jpg')}
              alt=''
              className='ui fluid block image'
            />
            <div className='ui container'>
              <figcaption className='ta caption'>
                Nicht gespielt, nein, echt muss er sein: Albert Pocej konnte 15
                Frauen für das Orgasmus-Experiment gewinnen.
              </figcaption>
            </div>
          </figure>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <Question
                q='Könnt ihr eurem Partner gegenüber artikulieren, was
                euch beim Sex gefällt?'
                classes='ui small red header'
              >
                <Answer who='Annabelle'>
                  <p>
                    Früher nicht. Es kam mir komisch vor, ich will doch keine
                    Anleitung geben. In den Beziehungen, die ich führte, hatten
                    wir immer genug Zeit, solche Dinge zusammen zu entwickeln.
                    Je häufiger man miteinander schläft, desto klarer wird, was
                    dem anderen gefällt.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>Es ist schwierig, zu formulieren, was einem gefällt.</p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Wenn man es sagt, ist die Luft ja schon draussen. Alles wird
                    dann so berechenbar.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Redet ihr mit dem Partner allgemein über Sex?'
                classes='ui small red header'
              >
                <Answer who='Lisa'>
                  <p>
                    In meiner zweiten, sechsjährigen Beziehung hatte ich
                    manchmal Lust auf Sex, und er konnte nicht. Ich wollte
                    wissen, was los ist, und seine Erklärung war, dass er durch
                    die vielen Pornos Schwierigkeiten hatte in der Realität,
                    weil sie so anders ist.{' '}
                  </p>
                  <p>
                    Er versuchte, weniger Pornos zu schauen, wenn wir uns am
                    Wochenende sahen. Der Sex wurde besser, aber nicht deutlich.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Erst jetzt: Mein Freund und ich finden es sehr wichtig,
                    darüber zu reden. Wenn etwas Lustiges passiert oder etwas
                    Komisches, wir reden darüber, was ihm gefällt, was mir
                    gefällt, über Probleme, die wir aus unseren vergangenen
                    Beziehungen kennen, damit wir sie vermeiden können. Wir
                    fragen uns auch gegenseitig viel, etwa, ob wir uns selbst
                    befriedigen. Das wusste ich von anderen Freunden nicht. So
                    kann sich die gemeinsame Sexualität auch entwickeln.
                  </p>
                </Answer>

                <Answer who='Anouk'>
                  <p>
                    Bei mir war immer das Thema, dass ich nicht leicht zum
                    Orgasmus komme. In der ersten Beziehung tat ich öfters so,
                    als wäre der Sex schön gewesen, um dieser Diskussion
                    auszuweichen. Hauptsache, er ist befriedigt und mein Job
                    erledigt.{' '}
                  </p>
                  <p>
                    Jetzt hinterfrage ich mich aber selber mehr: Mir gefällt
                    beim Sex die Intimität, aber ich kann den Kopf zu wenig
                    abstellen. Wenigstens habe ich den Druck, zu kommen, nicht
                    mehr.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Mit meinem ersten Freund, wir waren beide Anfang 20, redete
                    ich viel über Sex, auch während des Sex. Manchmal hilft das,
                    manchmal ist das auch der totale Killer. Durch Penetration
                    allein kriege ich keinen Orgasmus, das war am Anfang Thema,
                    inzwischen stimuliere ich mich manuell.
                  </p>
                  <p>
                    Anfangs war ich weniger an Sex interessiert als er, für ihn
                    war es ein Mittel, um Stress abzubauen. Seine Lust war
                    teilweise fast penetrant.
                  </p>
                  <p>
                    Heute ist es anders: Wenn er Stress bei der Arbeit hat,
                    weist er mich manchmal auch zurück. Das ist neu für mich.
                    Man fragt sich, liegt es an mir? Nach neun Jahren Beziehung
                    geht es auch darum, dass die Lust nicht einschläft. Es gab
                    mal eine Zeit, in der wir zusammen Pornos geschaut haben.
                  </p>
                </Answer>

                <Answer who='Zoé'>
                  <p>
                    Wir sind seit zehn Jahren zusammen. Vor etwa fünf Jahren
                    begann er sich zu beklagen, dass ich zu selten Sex wolle. Er
                    fühlte sich von mir zurückgewiesen, während ich fand, er sei
                    unersättlich. Das liegt aber auch daran, dass ich nie sagte,
                    was mir gefällt. Das weiss ich vielleicht gar nicht, ich
                    frage mich, ob ich überhaupt jemals einen Orgasmus hatte.
                    Ich weiss, dass er Pornos schaut, aber er hasst es, mit mir
                    darüber zu reden.
                  </p>
                  <p>
                    Es nähme mich wunder, was er schaut. Für ihn ist Sex Liebe
                    in ihrer reinsten Form. Für mich nicht unbedingt.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    In meiner dritten Beziehung war der Sex gut, trotzdem hatte
                    ich irgendwann keine Lust mehr. Das Problem war, dass ich
                    immer nur seine Befriedigung im Fokus hatte, nicht meine.
                    Das ist jetzt anders, weil ich in meiner Singlezeit merkte,
                    dass meine Lust da ist, sie teilweise die Männer sogar
                    überfordert.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Auch nach neun Jahren Beziehung kann ich schlecht
                    artikulieren, was ich gerne habe. Wahrscheinlich, weil ich
                    denke, als Frau sollte man das nicht so explizit sagen. Ich
                    fühle mich in dieser Lustposition nicht so wohl – oder nicht
                    geübt.
                  </p>
                </Answer>
              </Question>
            </div>
          </section>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <Question
                q='Gibt es Dinge, die euch anmachen, aber ihr wagt
                es nicht, dazu zu stehen?'
                classes='ui small red header'
              >
                <Answer who='Ivana'>
                  <p>
                    Vielleicht Rollenspiele. Vielleicht müsste ich sagen, sei
                    mal der Handwerker, aber ich mache es nicht, weil es zu
                    klischiert ist, ich bin wie gefangen darin.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Wahrscheinlich fürchtet man die Entblössung. Aber vielleicht
                    kann man darüber ja auch lachen. Es hiess immer, Lachen sei
                    der Stimmungskiller, aber das stimmt nicht. Man muss doch
                    viel lachen, wenn man irgendeinen Porno imitiert oder so und
                    es komisch aussieht.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Ihr habt alle mehr als zehn Jahre Erfahrung mit eurer Sexualität.
              Gibt es ein Erlebnis, das euch geprägt hat?'
                classes='ui small red header'
              >
                <Answer who='Rahel'>
                  <p>
                    Das Bewusstsein, dass Männer den gleichen Stress haben wie
                    wir, nämlich: performen zu müssen. In meiner Singlezeit, mit
                    diversen Sexpartnern, war ich viel sicherer als die Männer:
                    Sie hatten zittrige Stimmen, konnten nicht kommen,
                    entschuldigten sich dafür hundertmal.
                  </p>
                </Answer>

                <Answer who='Lisa'>
                  <p>
                    Bei meinem Ex war alles auf den Orgasmus fokussiert. Mit dem
                    neuen Freund habe ich schon beim ersten Mal gemerkt, dass es
                    auch anders sein kann. Es geht nicht nur um Sex, es geht um
                    uns beide.
                  </p>
                </Answer>

                <Answer who='Zoé'>
                  <p>
                    Bei mir war es die Erkenntnis, dass ich doch Lust empfinde,
                    einfach auf einen anderen Mann, nachdem ich mich in einen
                    anderen verliebt hatte. Aber ich traue ihr nicht so ganz und
                    fürchte, die Lust wird genauso vorbeigehen.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Kann Sex ohne Liebe befriedigend sein?'
                classes='ui small red header'
              >
                <Answer who='Zoé'>
                  <p>
                    Ja, offenbar schon, wenn ich jetzt darüber nachdenke, meine
                    Beziehung zu öffnen. Ich bin inzwischen davon überzeugt,
                    dass meine Sexualität ein bisschen anders ist. Trotzdem habe
                    ich diese Idealvorstellung, dass man als Paar auf jeder
                    Ebene zusammen funktionieren muss, besonders auf der
                    sexuellen Ebene. Ich merke erst jetzt, in Gesprächen mit
                    Freundinnen, dass es auch in einer scheinbare perfekten
                    Beziehung selten so ist.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Ich hatte auch die Idee der ewigen Liebe, so kitschig das
                    klingt. Diese Vorstellung, dass alles auf allen Ebenen
                    zusammenpassen muss, damit man als Paar perfekt
                    funktioniert. Ich habe diesen Zustand aber nie auch nur
                    annähernd erreicht! Irgendwann fragt man sich dann schon,
                    woher diese Vorstellungen kommen, wer die mir eingetrichtert
                    hat. Meine einzige richtige Antwort bis jetzt ist, dass es
                    keinen goldenen Weg gibt.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Bei mir gab es eine Phase, in der ich ausprobiert habe. Sie
                    war relativ kurz, aber extrem wichtig. Ich hatte
                    lustigerweise viel weniger das Gefühl, mich zu entblössen,
                    weil ich ja sonst nichts von den Männern wollte. Ich konnte
                    deshalb all das sein, was ich in meinem tiefsten, dunkelsten
                    Innern bin.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Habt ihr schon einmal sexuelle Gewalt erlebt?'
                classes='ui small red header'
              >
                <Answer who='Ivana'>
                  <p>
                    Ja. Es war im Ausland, in Mexiko, ich ging mit einem Typen
                    aus. Als er mich nach Hause brachte, blieben wir vor dem
                    Gartentor stehen, und er bedrängte mich massiv. Ich sagte
                    schon Nein, aber zu wenig bestimmt, jedenfalls hat er
                    einfach weitergemacht. Heute weiss ich, das war ein
                    Übergriff, damals wollte ich es nicht wahrhaben. Irgendwann
                    merkte ich, ich will es wirklich nicht, und habe ihn
                    weggestossen. Ich hätte wohl von Anfang an vehementer sein
                    sollen. Was blieb, ist dieses Gefühl: Dieser Typ macht
                    einfach, und ich wehre mich zu wenig.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Habt ihr manchmal auch Sex, damit der Partner Ruhe gibt?'
                classes='ui small red header'
              >
                <Answer who='Annabelle'>
                  <p>
                    In längeren Beziehungen gibt es Phasen, in denen man weniger
                    Lust hat. Aber einfach über sich ergehen lassen, das kenne
                    ich nicht.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Manchmal hat man nicht so Bock auf Sex, macht aber doch mit,
                    und plötzlich wird es gut. Das macht es schwierig: Ich
                    erwarte von mir, dass ich checke, ob ich jetzt Lust habe
                    oder nicht. Sich auf dieses Spiel einlassen und später
                    finden, das fühlt sich jetzt gut an, obwohl ich vorher gar
                    nicht wollte – damit schwäche ich ja mein eigenes Nein.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Habt ihr eine bestimmte sexuelle Fantasie, die ihr umsetzen
              möchtet?'
                classes='ui small red header'
              >
                {' '}
                <Answer who='Ivana'>
                  <p>
                    Als Kopfkino: ein Dreier mit zwei Männern. Ein Dreier mit
                    meinem Freund und einer anderen Frau kommt für mich aber
                    nicht infrage.
                  </p>
                </Answer>
                <Answer who='Anouk'>
                  <p>
                    Ich sehe das ähnlich, Fantasie ja, in der Realität würde ich
                    mich wohl von zwei Männern bedrängt fühlen.
                  </p>
                </Answer>
                <Answer who='Rahel'>
                  <p>
                    Dasselbe bei mir. Ein Dreier mit zwei Männern – aber die
                    Vorstellung, in einem Raum mit zwei dominanten, körperlich
                    stärkeren Männern zu sein, ist ein Risiko, das ich nicht
                    eingehen will.
                  </p>
                </Answer>
                <Answer who='Lisa'>
                  <p>
                    Bei mir gibt es keine Fantasien in Bezug auf jemand anderen,
                    mehr so auf eine andere Zeit, einen anderen Ort. Mehr aus
                    der Routine auszubrechen. Einfach mal anders, das ist ja
                    nichts Wahnsinniges.
                  </p>
                </Answer>
                <Answer who='Anouk'>
                  <p>
                    Es gibt schon Männer, die man irgendwo trifft und mit denen
                    man sich Sex ohne Konsequenzen vorstellt. Ich würde es nie
                    machen, aber manchmal sieht man jemanden an, und beide
                    wissen, was der andere jetzt gerade denkt. Vielleicht würde
                    es eine Beziehung nicht mal bedrohen, wenn so ein
                    Seitensprung tatsächlich stattfinden würde.
                  </p>
                </Answer>
                <Answer who='Ivana'>
                  <p>
                    Ich wüsste dann einfach nicht, wie damit umgehen. Weil ich
                    mich vielleicht verlieben würde, weil mit dieser sexuellen
                    Anziehung dann doch mehr verbunden ist. Meistens ist es eher
                    so: Ich will mit dir Sex haben, aber auch noch mit dir
                    reden.
                  </p>
                </Answer>
                <Answer who='Rahel'>
                  <p>
                    Und dann geht man gemeinsam frühstücken, und schon ist es um
                    einen geschehen.
                  </p>
                </Answer>
                <Answer who='Ivana'>
                  <p>
                    Bei meinem Freund ist das anders, der würde eher sagen:
                    Diese Frau finde ich geil, und der Sex wäre dann rein nur
                    auf das Körperliche bezogen.
                  </p>
                </Answer>
                <Answer who='Rahel'>
                  <p>
                    Lange ging ich davon aus, dass ich mich in jeden Mann
                    verliebe, mit dem ich Sex habe. Und dann muss man nachher
                    wieder drei Wochen lang traurig sein. Irgendwann habe ich
                    einfach entschieden, dass es nicht so sein muss. Man kann
                    auch Sex haben und einfach wieder gehen. Keine SMS
                    austauschen, nicht beieinander übernachten und dann noch
                    zusammen frühstücken. Das tat gut, zu merken, dass das auch
                    funktioniert.
                  </p>
                </Answer>
              </Question>
            </div>
          </section>

          <figure className='ui vertical very fitted segment'>
            <img
              className='ui fluid block image'
              src={require('./pocej-3.jpg')}
              alt=''
            />
            <div className='ui container'>
              <figcaption className='ta caption'>
                Die Fotos entstanden mit Zeitrafferfunktion, um den einen kurzen
                Moment nicht zu verpassen. Foto: Albert Pocej
              </figcaption>
            </div>
          </figure>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <Question
                q='Was haltet ihr von offenen Beziehungen?'
                classes='ui small red header'
              >
                <Answer who='Rahel'>
                  <p>
                    Man müsste sich klar absprechen. Aber auch dann: Wer kann
                    garantieren, dass er sich nicht in jemand anderen verliebt?
                    Auch wenn ich schon ganz knapp am Fremdgehen
                    vorbeigeschrammt bin, muss ich gestehen. Aber zu wissen,
                    dass ich damit meinen damaligen Partner betrogen und die
                    Beziehung riskiert hätte, hielt mich davon ab. Wenn ich den
                    anderen Typen unbedingt will, kann ich ihn auch ein paar
                    Wochen später haben, wenn ich die andere Sache geklärt habe.
                  </p>
                </Answer>

                <Answer who='Annabelle'>
                  <p>
                    In meiner langjährigen Beziehung haben wir oft über
                    bestehende und alternative Beziehungsformen geredet. Wir
                    waren sehr jung zusammengekommen, deshalb war das für uns
                    interessant. Aber es blieb beim Reden. Ich könnte das,
                    glaube ich, auch nicht umsetzen. Plötzlich verliebt man
                    sich, oder es kommt Eifersucht ins Spiel. Für gewisse
                    Beziehungen kann es aber sicher befreiend sein. Für mich
                    wäre es eher eine Belastung als eine Befreiung.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Den Gedanken finde ich spannend. Drei Freundinnen von mir
                    haben das versucht. Die Männer haben sich geholt, was sie
                    wollten, aber mein Eindruck war, dass Frauen bei diesem
                    Konzept zurückbleiben. Vielleicht, weil das Emotionale eine
                    grössere Rolle spielt.
                  </p>
                </Answer>

                <Answer who='Zoé'>
                  <p>
                    Mein Freund wollte viel mehr Sex als ich. Vor sechs Jahren
                    schlug er deshalb vor, die Beziehung zu öffnen. Ich empfand
                    das als grosse Beleidigung, weil ich das Gefühl hatte, genug
                    Sex zu liefern, eine akzeptable Statistik zu erfüllen.
                    Seither reden wir darüber, tun es aber nicht. Das ist auch
                    nicht gerade lustfördernd.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Heisst Treue einfach nur körperliche Exklusivität?'
                classes='ui small red header'
              >
                <Answer who='Ivana'>
                  <p>
                    Für mich fängt Untreue beim Körperlichen an. Wenn mein
                    Freund an andere Frauen denkt, stört mich das zwar, aber ich
                    kann damit umgehen. Wenn er mit jemand anderem Sex hätte,
                    wäre das für mich die grösstmögliche Grenzüberschreitung.
                    Gleichzeitig glaube ich nicht, dass Betrug nur durch
                    körperliches Fremdgehen geschieht.
                  </p>
                </Answer>

                <Answer who='Anouk'>
                  <p>
                    Eine Umarmung kann viel mehr mit Liebe zu tun haben als Sex.
                    Meine grösste Angst wäre nicht, dass mein Freund mit einer
                    anderen Frau schlafen würde, sondern dass er am Tisch sitzt
                    und diese Person auf eine bestimmte Weise anschaut, und ich
                    merke, diese Person ist für ihn jetzt mehr wert als ich.
                  </p>
                </Answer>

                <Answer who='Zoé'>
                  <p>
                    Ich bin sicher, dass für meinen Freund niemand anderes
                    wichtiger ist als ich. Das Körperliche ist ja ein zeitlich
                    beschränkter Akt. Aber das Emotionale geht weiter im Kopf.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Lustig, für mich ist das Körperliche länger anhaltend, weil
                    man ineinander drin war.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Ich stelle mir meine Zukunft so vor: Ich wäre gerne in einer
                    langen Beziehung mit meinem jetzigen Partner, aber
                    vermutlich werden wir irgendwann ein starkes Bedürfnis nach
                    Sex mit anderen haben. Das stresst uns beide jetzt schon.
                    Meine Wunschvorstellung wäre, mit einem Lifebuddy eine
                    Familie zu haben, diesen Teil kann dir niemand nehmen. Sex
                    ist dabei so ein kleiner Teil des ganzen Package, dass man
                    dort sagen kann: Mach, was du willst, solange es keine
                    Gefahr wird für diese Lebenspartnerschaft. Ich weiss aber
                    nicht, wie realistisch diese Vorstellung ist.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Garantiert eine offene Kommunikation, dass auch eine offene
              Beziehung klappt?'
                classes='ui small red header'
              >
                <Answer who='Rahel'>
                  <p>
                    Man ist sicher besser vorbereitet, wenn man darüber geredet
                    hat. Aber ich möchte es wohl gar nicht so genau wissen.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Ich hätte dann wahrscheinlich das Bedürfnis, es ihm
                    heimzuzahlen, wenn er mir das antun würde.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Ja, natürlich! Und darum müsste die Regel sein, dass man
                    einander gar nicht davon erzählt. Das ist aber natürlich ein
                    Problem, wenn man zusammenwohnt und er über Nacht nicht
                    heimkommt. Dann fängt das Spiel schon an. Es gibt keine
                    Lösung.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Diese Exklusivität ist für mich in einer Beziehung schon
                    wichtig. Dass er immer auf mich zurückkommt, weil ich die
                    Beste bin.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Das will ich ja auch, aber wenn dein Freund sich nur noch so
                    verhält, weil er das Gefühl hat, er müsse, dann ist es ja
                    auch nicht mehr gut. Was nützt dir das dann?
                  </p>
                </Answer>
              </Question>

              <Question
                q='Warum klammern wir uns ans Ideal der romantischen Zweierbeziehung?'
                classes='ui small red header'
              >
                <Answer who='Rahel'>
                  <p>Disney, Filme, Romane.</p>
                </Answer>

                <Answer who='Annabelle'>
                  <p>
                    Stabilität gibt Ruhe. Ich finde Langeweile schön, so
                    entspannend.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Wenn ich mich langweile, die Oberhand habe, muss ich weiter.
                    Ich möchte ja auch Langeweile cool finden, aber ich schaffe
                    es einfach nicht. Ich fürchte die Routine.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>Dann macht man halt Kinder.</p>
                </Answer>

                <Answer who='Anouk'>
                  <p>
                    Eine Familie zu gründen, heisst ja nicht, dass man als Paar
                    auch zusammenbleiben muss. Ich kann mir vorstellen, dass das
                    einfach ein Lebensabschnitt ist, und diese Person wird dich
                    immer begleiten. Der Vater deiner Kinder muss ein Typ sein,
                    den du in den nächsten zehn Jahren nicht verabscheuen wirst
                    für das, was er ist.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Warum reden junge Frauen so wenig über Sex?'
                classes='ui small red header'
              >
                <Answer who='Annabelle'>
                  <p>
                    Das ist eine Frage der Persönlichkeit. Das Alter spielt auch
                    eine Rolle, im Zusammenhang mit Erfahrungen und bestimmten
                    Fragen und Problemen.
                  </p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Bei mir hat es mit Stabilität zu tun, die ich langsam
                    gefunden habe. Mit 30 fühle ich mich langsam sicherer,
                    weiss, wer ich bin, was ich will. Zuvor hätte ich mich nicht
                    getraut, zuzugeben, dass ich etwas nicht schaffe. Jetzt kann
                    ich darüber reden, ohne dass es gerade meine ganze Person
                    untergräbt. Ich hätte mir gewünscht, das schon früher zu
                    können.
                  </p>
                </Answer>

                <Answer who='Anouk'>
                  <p>
                    Bei manchen Freundinnen würde ich mich zu wenig verstanden
                    fühlen, um mich so offen zu zeigen. Man hat eine Fassade,
                    hinter die nicht jeder blicken soll. Das hat auch mit einer
                    eigenen Schwäche zu tun.
                  </p>
                </Answer>

                <Answer who='Zoé'>
                  <p>
                    Man will auch ein Bild aufrechterhalten, nicht nur nach
                    aussen, sondern auch sich selbst gegenüber. Freundinnen, die
                    langjährige Singles sind, haben spannendere Geschichten zu
                    erzählen, weil auch die Partner immer wieder wechseln. Und
                    ich will meinen Partner nicht so vor ihnen entblössen.
                  </p>
                </Answer>

                <Answer who='Rahel'>
                  <p>
                    Was noch dazu kommt: Was nicht formuliert ist, existiert
                    auch gar nicht. So kann ich mich selber besser belügen. Und
                    man hat auch keine Vorbilder. Jede von uns ist schon früh zu
                    einer Frauenärztin gegangen. Aber wurde je jemand von uns
                    auf Dinge wie Selbstbefriedigung angesprochen? Nie. Das will
                    ich mit meiner Tochter ganz anders machen.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Haben es Männer mit ihrer Sexualität einfacher?'
                classes='ui small red header'
              >
                <Answer who='Ivana'>
                  <p>
                    Ich glaube, die Jungs hatten es immer einfacher als die
                    Mädchen. Bei den Mädchen ist das immer grusig, peinlich,
                    schrecklich.
                  </p>
                </Answer>

                <Answer who='Lisa'>
                  <p>Das glaube ich gar nicht!</p>
                </Answer>

                <Answer who='Ivana'>
                  <p>
                    Im Skilager lagen im Knabenschlag Sexheftli herum, sie haben
                    voreinander gewichst.
                  </p>
                </Answer>

                <Answer who='Anouk'>
                  <p>Aber stell dir diesen Druck vor!</p>
                </Answer>

                <Answer who='Annabelle'>
                  <p>
                    Jungs und Männer müssen doch eher immer performen. Dass es
                    ein Thema ist bei ihnen, kann es für sie gerade noch
                    schwieriger machen.
                  </p>
                </Answer>

                <Answer who='Lisa'>
                  <p>
                    Ich habe mich immer gefragt, wie das für einen Buben
                    eigentlich ist, wenn er morgens aufwacht und eine Erektion
                    hat, Spuren auf der Bettwäsche, welche die Mutter dann
                    wäscht. Sprechen die dann darüber? Ich weiss es nicht, ich
                    habe keine Brüder. Ich stelle mir das schrecklich vor.
                  </p>
                </Answer>
              </Question>
            </div>

            {/* {(this.state.articleLoaded == true) ? <Tracking articleId='20846117'/> : null} */}
          </section>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'contentBottom'
                })
              }
            }}
          />
        </main>
      </div>
    )
  }

  showArticle(event) {
    this.setState({
      overlayDisplay: 'none',
      followupClass: 'expanded',
      articleLoaded: true
    })
  }
}

FollowUp.propTypes = {}

FollowUp.defaultProps = {}
